<span>
  <label class="k-label">
    {{ acknowledgementMessage }}
    <input #checkbox type="checkbox" kendoCheckBox [required]="true" (change)="onChange($event.target['checked'])" />
  </label>
</span>
